<template src="./review-form-header.html"></template>

<script lang="ts">
import globalConfig from 'init/global.config'
import { hostsConfig } from 'init/config'
import ProductImage from 'objects/product-image/ProductImage.vue'

/**
 * There are 2 different header layouts.  The 'productTop' prop determines which to display.
 * If true, then option 1, otherwise option 2
 * 1) Where the product title and image are in the top section of the header.
 * 2) Where the product title and image are below the heading and description.
 */
export default {
  data() {
    return {
      globalConfig,
      showGuidelines: false
    }
  },
  components: {
    'tt-product-image': ProductImage
  },
  props: {
    catItem: Object,
    description: String,
    forSellerRating: Boolean,
    guidelinesOpen: Boolean,
    hasGuidelines: Boolean,
    heading: String,
    logoFileName: String, // for seller rating
    siblingSiteKey: String,
    eriCampaignMessage: String,
    isEriCampaignActive: Boolean
  },
  computed: {
    glLinkText() {
      return this.$msg(`revForm.${this.showGuidelines ? 'hide' : 'review'}Guidelines`)
    },
    hasImage() {
      return this.catItem || this.forSellerRating
    },
    glPrefix() {
      return this.forSellerRating ? 'srForm.' : 'revForm.'
    },
    glTexts() {
      return [
        this.$msg(`${this.glPrefix}guidlines.input`),
        this.$msg(`${this.glPrefix}guidlines.support`),
        this.$msg(`${this.glPrefix}guidlines.rules.header`)
      ]
    },
    siteLogo() {
      return this.logoFileName ? `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/` +
        `site/sellerratinglogos/${this.logoFileName}` : ''
    }
  },
  methods: {
    toggleGuidelines() {
      this.showGuidelines = !this.showGuidelines
    }
  },
  created() {
    if (this.guidelinesOpen) {
      this.showGuidelines = true
    }
  }
}
</script>

<style lang="scss" src="./review-form-header.scss"></style>
